'use client';

import { ReactElement, useEffect, useRef } from 'react';
import useOfferComparisonStore from '@/app/store/use-offer-comparison-store';

export default function OfferSection({ children }: { children: ReactElement }) {
  const offer = useOfferComparisonStore((state) => state.offer);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!offer || !scrollContainerRef.current) {
      return;
    }
    scrollContainerRef.current?.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  }, [offer]);

  return (
    offer && (
      <div
        className="bg-[var(--color-background-primary)]  w-full"
        ref={scrollContainerRef}
        data-testid="offerSection"
      >
        <div className="padded-container pt-10 pb-20 md:pt-15 md:pb-28">
          {children}
        </div>
      </div>
    )
  );
}
